import { createSlice } from "@reduxjs/toolkit";

const initialState={
    Count : "0"
}
 
const NotificationCountSlice = createSlice({
    name:"NotificationCount",
    initialState,
    reducers:{
        NotificationCount :(state,action)=>{
            state.Count = action.payload
        },
    },
})

export default NotificationCountSlice.reducer
export const {NotificationCount} = NotificationCountSlice.actions
